import React, { useEffect, useState } from 'react';
import { CCard, CCardBody, CCardHeader, CCol, CRow, CButton } from '@coreui/react';
import { DataGrid } from '@mui/x-data-grid';
import { Link, useLoaderData } from 'react-router-dom';
import AxiosInstance from 'src/components/Axios';
import { cilPen, cilPlus, cilTrash } from '@coreui/icons';
import CIcon from '@coreui/icons-react';
import { confirmAlert } from 'react-confirm-alert';
import PermissionsNoPage, { Permissions } from "src/components/Permissions";
import CustomPagination from 'src/components/pagination/CustomPaginatiion';

// const urlApi = '/forms';
const urlApi = '/form_answers';
const urlRouter = '/form-answer';

const page = 1;
const postPerPage = 0;
const pageSize = 20;

const statuses = [
    { value: 'new', label: 'Нове' },
    { value: 'opened', label: 'Відкрите' },
    { value: 'in_work', label: 'В роботі' },
    { value: 'send_answer', label: 'Надіслано відповідь' },
];

export async function LoaderFormsAnswer({ params }) {
    let res = await AxiosInstance.get(`${urlApi}?page=${page}`).then((response) => {
        return response;
    });
    return res;
}

// Заповнені форми 
const FormsAnswer = ({ user_data }) => {
    if (!Permissions(user_data, 'FormAnswer', 'VIEW_FORMANSWER')) {
        return <PermissionsNoPage />;
    }
    const { data } = useLoaderData();
    const [rows, setRows] = useState(false);
    const [rowCountState, setRowCountState] = React.useState(0);

    if (!rows) {
        setRowCountState(data['hydra:totalItems'])
        setRows(data['hydra:member']);
    }
    const getRowsTable = (p = 1) => {
        AxiosInstance.get(`${urlApi}?page=${p}`).then((response) => {
            setRows(response.data['hydra:member']);
        });
    };
    const handlePageChange = (page) => {
        getRowsTable(page + 1);
    };

    function Deleted(row) {
        confirmAlert({
            title: 'Ви впевнені що хочите видалити цей пункт ?',
            message: 'Are you sure to do this.',
            buttons: [
                {
                    label: 'Так',
                    onClick: () => {
                        const response = AxiosInstance.delete(`${urlApi}/${row.id}`).then((response) => {
                            alert("Форму видалено")
                            getRowsTable();
                        });
                    }
                },
                {
                    label: 'Ні',
                    onClick: () => {
                        return;
                    }
                }
            ]
        });
    };

    const columns = [
        {
            field: 'id',
            headerName: 'ID',
            sortable: false,
            disableColumnMenu: true,
            width: 70
        },
        // { field: 'name', headerName: 'Назва', width: 300 },
        {
            field: 'name',
            headerName: 'Назва',
            sortable: false,
            disableColumnMenu: true,
            width: 180,
            // editable: true,
            renderCell: (params) => (
                <>{params.row.form.name}</>
            )
        },
        {
            field: 'description',
            headerName: 'Опис',
            sortable: false,
            disableColumnMenu: true,
            width: 450,
            renderCell: (params) => (
                <>{
                    (params.row.formAnswerFields.map((row) => {
                        return <><strong>{row.formField.label}</strong>{row.value} | </>;
                    }))
                }</>
            )
        },
        {
            field: 'dateEntered',
            headerName: 'Дата',
            type: 'date',
            sortable: false,
            disableColumnMenu: true,
            width: 160,
        },
        {
            field: "status",
            width: 200,
            headerName: "Статус",
            sortable: false,
            sortable: false,
            disableColumnMenu: true,
            renderCell: (params) => {
                let s = statuses.filter(row => row.value == params.row.status)


                return (s.length > 0) ? s[0].label : '';
            }
        },
        {
            field: "action",
            headerName: "Action",
            sortable: false,
            headerName: "",
            headerClassName: "hide-header",
            align: 'center',
            width: 70,
            // renderCell: (params) => {
            //     return <Link to={`${urlRouter}/review/${params.row.id}`}><CButton color="dark" variant="outline"><CIcon icon={cilPen} customClassName="nav-icon" height={20} /></CButton></Link>;
            // }
            renderCell: (params) => {
                return <Link to={`${urlRouter}/review/${params.row.id}`}><img src="/edit.svg" alt="edit" /></Link>;
            }
        },
        {
            field: "delete",
            headerName: "Видалити",
            sortable: false,
            headerName: "",
            headerClassName: "hide-header",
            align: 'center',
            width: 70,
            // renderCell: (params) => {
            //     return <CButton color="danger" variant="outline" onClick={() => {
            //         Deleted(params.row)
            //     }
            //     }><CIcon icon={cilTrash} customClassName="nav-icon" height={20} /></CButton>;
            // }
            renderCell: (params) => {
                return <button className='transparent' onClick={() => Deleted(params.row)}><img src="/delete.svg" alt="delete" /></button>
            }
        },
    ];

    return (
        <>
            <CRow>
                <CCol xs={12}>
                    <CCard className="mb-4 mt-4">
                        <CCardHeader className='items_card_header'>
                            {/* <strong> */}
                            Відповіді
                            {/* </strong>  */}
                            <small></small>
                        </CCardHeader>
                        <CCardBody>
                            {/* <p className="text-medium-emphasis small">
                                <Link to={`${urlRouter}/create`}><CButton color="secondary"><CIcon icon={cilPlus} customClassName="nav-icon" height={15} />Створити</CButton></Link>
                            </p> */}
                            <div style={{ height: 600, width: '100%' }}>
                                <DataGrid
                                    rows={rows}
                                    columns={columns}
                                    pageSize={30}
                                    rowsPerPageOptions={[30]}
                                    pagination
                                    rowCount={rowCountState}
                                    paginationMode="server"
                                    onPageChange={handlePageChange}
                                    getRowClassName={(params) => {
                                        if (params.row.status == 'new' || params.row.status == '' || params.row.status == null)
                                            return 'rowAnswerNew';
                                        if (params.row.status == 'opened' || params.row.status == 'in_work')
                                            return 'rowAnswerOpened';
                                        if (params.row.status == 'send_answer')
                                            return 'rowAnswerSend';
                                    }
                                    }

                                    components={{ Pagination: CustomPagination }}
                                    headerHeight={44}

                                    sx={{
                                        borderRadius: '12px',
                                        border: '1px solid #ccc',

                                        '& .MuiDataGrid-main': {
                                            // borderRadius: '12px',
                                        },
                                        '& .MuiDataGrid-columnHeaders': {
                                            borderTopLeftRadius: '12px',
                                            borderTopRightRadius: '12px',
                                            fontFamily: 'Inter',
                                            fontWeight: '600',
                                            fontSize: '12px',
                                            lineheight: '150%',
                                            color: '#717680',
                                            //   borderBottom: '2px solid #4e73df',

                                        },
                                        '& .MuiDataGrid-cell': {
                                            fontFamily: 'Inter',
                                            fontWeight: 500,
                                            fontSize: '14px',
                                            color: '#434349',
                                        },
                                        '& .MuiDataGrid-footerContainer': {
                                            // borderBottomLeftRadius: '12px',
                                            // borderBottomRightRadius: '12px',
                                        },
                                    }}
                                />
                            </div>
                        </CCardBody>
                    </CCard>
                </CCol>
            </CRow>
        </>
    );
};

export default FormsAnswer;